import { topbarDesktop, topbarMobile } from './effets/topbar';
import {
    enrichirMenu,
    ouvrirMenu,
    ouvrirSousMenu,
    retourMenu,
} from './effets/menu';
import { stickyHeader } from './effets/header';

document.addEventListener('DOMContentLoaded', () => {
    const mobileBreakpoint = 1200;
    const topbarSelector = '#topbar';
    const topbarItemsSelector = '.menu-item';
    const desktopClassname = 'headerSite-topbar';
    const mobileClassname = 'headerSite-topbar--mobile';
    const mobileContainerSelector = '#topbar-mobile-container';
    const desktopContainerSelector = '#myHeader';

    // HEADER //
    window.addEventListener('scroll', () => {
        stickyHeader();
    });

    // TOPBAR //
    // Initialisation de base
    switchTopbar();
    // On écoute l'événement resize pour changer adapter la topbar
    window.addEventListener('resize', () => {
        switchTopbar();
    });

    // MENU //
    // Enrichissement du menu mobile
    enrichirMenu();
    // Ouverture du menu mobile
    ouvrirMenu();
    // Navigation dans le menu mobile
    let animEnCours = false;
    animEnCours = ouvrirSousMenu(mobileBreakpoint, animEnCours);
    retourMenu(animEnCours);

    function switchTopbar() {
        if (window.innerWidth < mobileBreakpoint) {
            topbarMobile(
                topbarSelector,
                topbarItemsSelector,
                mobileClassname,
                desktopClassname,
                mobileContainerSelector
            );
            enrichirMenu();
            ouvrirSousMenu();
        } else {
            topbarDesktop(
                topbarSelector,
                topbarItemsSelector,
                mobileClassname,
                desktopClassname,
                desktopContainerSelector
            );
            // Tooltips
            $('[data-toggle="tooltip"]').tooltip();
        }
    }
});
